/*
 * サブシステム名：マスタ管理
 * 機能名：種別マスタ登録
 */
// import DdFooterButton from '@/components/DdFooterButton'
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'
import { mapGetters } from 'vuex'
// import message from '@/ddv2.library/messages'
import header from '@/ddv2.library/header'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdHimodukeHaishahyoAddButton = () => import('@/components/DdHimodukeHaishahyoAddButton')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')

export default {
  name: 'MstShubetsuEdit',
  mixins: [flowMixin],
  data: () => ({
    id: 0,
    rec: {},
    hyojiFlg: false,
    invalidMessages: {},
    modeOfEdit: 2,
    modeKengen: 2,
    showCopyDialog: false,
    kbnSbtId: 0,
    headersKbnSbtShuruiList: header.msysKubunShubetsuShurui
  }),
  components: {
    DdSubHeader,
    DdTextBox,
    DdDropDown,
    DdCheckbox,
    // DdFooterButton,
    DdNumericBox,
    DdCodeTextBox,
    DdHimodukeHaishahyoAddButton,
    DdIconButtonWithTooltip,
    DdCustomButton,
    DdTransparentButton
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunshubetsushuruiList: 'DDMasters/msysKubunShubetsuShurui',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    // 種別マスタ
    filteredShubetsuList () {
      return this.shubetsuList.filter(function (elem) {
        return elem.sbtShuruiCd
      }).map(function (elem) {
        elem.value = elem.sbtCd
        elem.text = elem.sbtNm
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.sbtCd > elem2.sbtCd) { return 1 }
        if (elem1.sbtCd === elem2.sbtCd) { return 0 }
        return -1
      })
    },
    // 区分種別種類
    filteredKubunShubetsuShurui () {
      return this.kubunshubetsushuruiList.filter(function (elem) {
        return elem.kbnSbtKbn === 'S'
      }).map(function (elem) {
        elem.value = elem.kbnSbtShuruiCd
        elem.text = elem.kbnSbtShuruiNm
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.kbnSbtShuruiCd > elem2.kbnSbtShuruiCd) { return 1 }
        if (elem1.kbnSbtShuruiCd === elem2.kbnSbtShuruiCd) { return 0 }
        return -1
      })
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isRirekiFukusyaDisplay () {
      console.log('モード', this.modeOfEdit, this.modeKengen)
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        return true
      }
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
    this.kbnSbtId = this.$route.params.msysksid
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/mstshubetsu/find?id=${this.id}`)
          .then((data) => {
            self.rec = data.payload
            resolve()
          })
      })
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['mstshubetsu', 'msyskubunshubetsushurui'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.rec = {
              hyojiOrder: '9999',
              hyojiFlg: true,
              sbtShuruiCd: self.getKubunShuruiCd(self.kbnSbtId)
            }
            console.log('xxx', self.rec, self.kbnSbtId)
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            console.log('★savedInputRestorePromise', c)
            console.log('★savedInputRestorePromise', self.rec)
            // ユーザ保存項目の復元
            var hyojiFlgBool = c.hyojiFlg === 'true'
            // self.rec = { ...self.rec, c }
            self.rec.hyojiFlg = hyojiFlgBool
            console.log('★savedInputRestorePromise', self.rec)
            resolve()
          })
        },
        existsIdMethod: function () {
          return self.id !== 0
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    // 戻るボタン
    onReturnButtonClick: function (e) {
      const self = this
      console.log('onReturnButtonClickSelfId', self.id)
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.transitionBack(opt)
    },
    // キャンセルボタン
    onCancelButtonClick: function (e) {
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data()
            self.rec.id = self.id
            resolve()
          })
        }
      }
      this.cancelInputs(opt)
    },
    // 削除処理
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.delete(`/api/v1/MstShubetsu/Delete?id=${self.id}&tm=${self.rec.timestamp}`).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          self.modeOfEdit = 0
          console.log('clear id', this.rec)
        }
      }
      this.copyInputs(opt)
    },
    // 保存ボタン
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
          return (data.sbtCd !== this.rec.sbtCd || data.sbtShuruiCd !== this.rec.sbtShuruiCd)
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            console.log('continuousInputInitializePromise')
            this.id = id
            this.transition(1, { id: id }, this.initialize)
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          console.log('isUpdateModeMethod')
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          console.log('★getSavedInputMethod:', self.rec.hyojiFlg)
          return {
            hyojiFlg: self.rec.hyojiFlg
          }
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      let f
      if (this.id === 0) {
        f = this.HttpClient.post('/api/v1/MstShubetsu/create', this.rec)
      } else {
        f = this.HttpClient.put(`/api/v1/MstShubetsu/update?id=${this.id}`, this.rec)
      }
      return f
    },
    // 入力チェック
    registerValidate: function () {
      var ret = true
      const msg = validators.compareDate(this.rec.tekiyoStartYmdString, this.rec.tekiyoEndYmdString)
      if (msg !== undefined) {
        this.$refs.tekiyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.tekiyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        ret = false
      }

      return ret
    },
    deleteValidate: function () {
      return true
    },
    getKubunShuruiCd: function (pKbnShuruiId) {
      var kubun = this.filteredKubunShubetsuShurui.filter((t) => {
        return t.id === pKbnShuruiId
      })
      console.log('xxxxxx', this.filteredKubunShubetsuShurui, kubun, pKbnShuruiId)
      if (kubun.length > 0) {
        return kubun[0].kbnSbtShuruiCd
      }
      return ''
    }
  }
}
